import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-8 h-full box-shadow-profile border" }

import { computed, onMounted, markRaw } from "vue";
import { useRouter } from "vue-router";
import ShareholderCard from "@/components/molecules/ShareholderCard.vue";
import TabTemplate from "@/components/templates/TabTemplate.vue";
import ShareholderIdentificationTab from "@/views/admin/tabs/ShareholderIdentificationTab.vue";
import ShareholderSharesTab from "@/views/admin/tabs/ShareholderSharesTab.vue";
import { useShareholderStore } from "@/stores/shareholder";
import ShareholderNotificationSettingsTab from "./tabs/ShareholderNotificationSettingsTab.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ShareholderDetailView',
  setup(__props) {


const shareholderStore = useShareholderStore();
const router = useRouter();

const shareholderId = computed(() =>
  Number(router.currentRoute.value.params.id)
);

onMounted(() => {
  shareholderStore.query(shareholderId.value);
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ShareholderCard, { class: "col-span-8 border-b-[#9BB441] border-b-[20px]" }),
    _createVNode(TabTemplate, {
      class: "col-span-8 p-8 gap-4",
      tabs: [
        { name: 'Identificación', view: markRaw(ShareholderIdentificationTab) },
        { name: 'Acciones', view: markRaw(ShareholderSharesTab) },
        {
          name: 'Notificaciones',
          view: markRaw(ShareholderNotificationSettingsTab),
        },
      ]
    }, null, 8, ["tabs"])
  ]))
}
}

})